import styled from 'styled-components'

const Placeholder = styled.div`
  // Placeholder to avoid page shifting down after loading
  width: 240px;
  height: 71px;
`

export { Placeholder }
